import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import type { LowInventoryNotificationBody } from '~/types/services/parityNotifications';

import { parityNotificationQueryKeys } from './parityNotificationQueryKeys';

export function useCreateLowInventoryNotification(onSuccess?: () => void) {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: LowInventoryNotificationBody) => ParityNotificationsService.postLowInventoryNotification(body),
    onSuccess: (created) => {
      enqueueSnackbar(`Notification created — ID: ${created.id}`, { variant: 'success' });
      queryClient.invalidateQueries({ queryKey: parityNotificationQueryKeys.unsolvedLowInventory() });
      onSuccess?.();
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
    },
  });
}
